import { cn } from "../../lib/utils.ts";
import appleCalendarIcon from "./apple-calendar.png";

export const AppleIcon = ({ className }: { className?: string }) => {
  return <img src={appleCalendarIcon} alt="Apple Calendar" className={cn(className)} />;
};
